import { createSelector } from 'reselect';

const getHasLoaded = createSelector(
  (state) => state.climbStepThreeCollections.hasLoaded,
  (hasLoaded) => hasLoaded
);
const getCurrencyData = createSelector(
  (state) => state.climbStepThreeCollections.data.currency,
  (currency = {}) => currency
);
const getCollectionsData = createSelector(
  (state) => state.climbStepThreeCollections.data.climbStepThreeCollections,
  (collections = []) => collections
);
const getPageCount = createSelector(
  (state) => state.climbStepThreeCollections.data.pageCount,
  (pageCount) => pageCount || 0
);

export default {
  getCollectionsData,
  getCurrencyData,
  getHasLoaded,
  getPageCount,
};
